// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1SsEz","head":"Table_head__1_qnF","col":"Table_col__2jZRQ"};